import React from 'react'

import styles from "./styles.module.scss"
import clsx from 'clsx'

export default function PaymentSplitButton({ text, amount, onClick, selected, disabled, greyedOut }) {
    return (
        <div className={clsx([styles.paymentSplitItem,
        selected && styles.active,
        disabled && styles.disabled,
        greyedOut && styles.greyedOut
        ])}
            onClick={disabled ? () => { } : onClick}
        >
            <div className={styles.paymentSplitItemText}>{text}</div>
            <div className={styles.paymentSplitItemAmount}>${amount}</div>
        </div>
    )
}
